import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { Route, Switch, Redirect } from "react-router-dom";
import withRouter from "components/withRouter";
import HomePage from "containers/HomePage/Loadable";
import FeaturePage from "containers/FeaturePage/Loadable";
import NotFoundPage from "containers/NotFoundPage/Loadable";
import Header from "components/Header";
import Footer from "components/Footer";
import NewUploadPage from "containers/eInv/NewUploadPage/Loadable";
import UploadPage from "containers/eInv/UploadPage/Loadable";
import UploadPageB2C from "containers/eInv/UploadPageB2C/Loadable";
import LoginPage from "containers/LoginPage/Loadable";
import NewLoginPage from "containers/LoginPage/NewLogin";
import LandingPage from "containers/LandingPage/Loadable";
import ProfilePage from "containers/ProfilePage/Loadable";
import UploadGstin from "containers/GSTINValidation/UploadPage/Loadable";
import TrackReturn from "containers/GSTINValidation/TrackReturn/Loadable";
import VendorMaster from "containers/GSTINValidation/VendorMaster/Loadable";
import InvoiceDetail from "containers/InvoiceDetail/Loadable";
// import DataAnalytics from "containers/DataAnalytics/Loadable";
import AnalyticsGSRT1VS3B from "containers/Analytics/GSTR1vsGSTR3B/Loadable";
import GSTR3BVSGSTR2A from "containers/Analytics/GSTR3BvsGSTR2A-2B/Loadable";
import EWayBillReco from "containers/Analytics/EWayBillReco/Loadable";
import ReturnFilling from "containers/Analytics/ReturnFilling/Loadable";
import RCMLiability from "containers/Analytics/RCMLiability/Loadable";
import TurnOverAnalysis from "containers/Analytics/TurnOverAnalysis/Loadable";
import HSNAnalysis from "containers/Analytics/HSNAnalysis/Loadable";
import HSNAnalysisInward from "containers/Analytics/HSNAnalysisInward/Loadable";
import TaxDischargedAnalysis from "containers/Analytics/TaxDischargedAnalysis/Loadable";
import ITCAnalysis from "containers/Analytics/ITCAnalysis/Loadable";
import CreditNoteAnalysis from "containers/Analytics/CreditNoteAnalysis/Loadable";
import LedgerBalanceAnalysis from "containers/Analytics/LedgerBalanceAnalysis/Loadable";
import DataFetchHome from "containers/DataFetch/UploadPage/Loadable";
import CashITCBalance from "containers/DataFetch/CashITCPage/Loadable";
import CashITCLedger from "containers/DataFetch/CashITCLedger/Loadable";
import SupplierDetails from "containers/SupplierInfo/Loadable";
import FailedInvoice from "containers/eInv/FailedInvoice/Loadable";
import ProcessedInvoice from "containers/eInv/ProcessedInvoice/Loadable";
import ConsolidateInvoice from "containers/eInv/ConsolidateInvoice/Loadable";
import UploadProgress from "containers/eInv/UploadProgress/Loadable";
import Reports from "containers/eInv/Reports/Loadable";
import ScheduleProgress from "containers/eInv/ScheduleProgress/Loadable";
import EwayBill from "containers/eInv/EwayBill/Loadable";
import B2CInvoice from "containers/eInv/B2CInvoices/Loadable";
import B2CInvoices from "containers/B2C/B2CInvoices/Loadable";
import B2CUploadPage from "containers/B2C/UploadPageB2C/Loadable";
import B2CNewUploadPage from "containers/B2C/NewUploadPage/Loadable";
import NewB2CInvoices from "containers/B2C/NewB2CInvoices/Loadable";
import gstr2A from "containers/gstr2A/index";
// import UploadAnx1 from "containers/anx1/UploadAnx1/Loadable";
// import UploadedDataAnx1 from "containers/anx1/UploadedData/Loadable";
// import DataFetch from "containers/anx1/DataFetch/Loadable";
// import Reconciliation from "containers/anx1/Reconciliation/Loadable";
// import Gstare2aFileProgress from "containers/anx1/FileProgress/Loadable";
// import Gstr2aPendingInvoices from "containers/anx1/PendingInvoices/Loadable";
// import PurchaseSummary from "containers/anx1/PurchaseSummary/Loadable";
// import Gstr2bReconciliation from "containers/anx1/GSTR2B/Loadable";
// import FailedAnx1 from "containers/anx1/FailedAnx1/Loadable";
import Logout from "containers/Logout/Loadable";
import UploadGstr1 from "containers/gstr1/UploadPage/Loadable";
import UploadedDataGstr1 from "containers/gstr1/UploadedData/Loadable";
import UploadedDataGstr9 from "containers/gstr9/UploadedData/Loadable";
import PrepareGSTR9C from "containers/gstr9C/PrepareGSTR9C/Loadable";
import SaveGSTR9C from "containers/gstr9C/SaveGSTR9C/Loadable";
import PreviewAndSubmit from "containers/gstr1/PreviewAndSubmit/Loadable";
import Summary from "containers/gstr1/Summary/Loadable";
import UploadProgres from "containers/gstr1/ProgressPage/Loadable";
import Gstr1DataUpload from "containers/gstr1New/DataUpload/Loadable";
import Gstr1FetchAndReconcile from "containers/gstr1New/Fetch&Reconcile/Loadable";
import Gstr1ViewData from "containers/gstr1New/ViewData/Loadable";
import Gstr1Save from "containers/gstr1New/Save/Loadable";
import Gstr1File from "containers/gstr1New/File/Loadable";
import SaveGstr1 from "containers/gstr1/SaveGstr1/Loadable";
import SaveGstr9 from "containers/gstr9/SaveGstr9/Loadable";
import UploadGstr3b from "containers/gstr3b/UploadPage/Loadable";
import SavePageGSTR3B from "containers/gstr3b/SavePage/Loadable"
import UploadGstr9 from "containers/gstr9/UploadPage/Loadable";
import UploadedDataGstr3b from "containers/gstr3b/ProgressPage/Loadable";
import FileProgressGstr3b from "containers/gstr3b/FileProgressPage/Loadable";
import PreviewAndSubmitR3B from "containers/gstr3b/PreviewAndSubmit/Loadable";
import SummaryR3B from "containers/gstr3b/Summary/Loadable";
import UploadEwayBill from "containers/ewaybill/UploadPage/Loadable";
import EwayBillPartB from "containers/ewaybill/EwayBillPartB/Loadable";
import EwayBillConsolidate from "containers/ewaybill/EwayBillConsolidate/Loadable";
import EwayBillGet from "containers/ewaybill/EwayBillGet/Loadable";
import UserManagement from "containers/Admin/UserManagement/Loadable";
import ManagePassInv from "containers/Admin/ManagePassInv/Loadable";
import ManagePincode from "containers/Admin/ManagePincode/Loadable";
import ManageHsncode from "containers/Admin/ManageHsncode/Loadable";
import UserModule from "containers/Admin/UserModules/Loadable";
import ProfileManagement from "containers/Admin/Profile/Loadable";
import ManageModules from "containers/Admin/ManageModules/Loadable";
import ManageCompanies from "containers/Admin/ManageCompanies/Loadable";
import ManageGroup from "containers/Admin/ManageGroup/Loadable";
import CompanyDetail from "containers/Admin/ManageCompanies/CompanyDetail";
import AdminSetting from "containers/Admin/Settings/Loadable";
import AdminReport from "containers/Admin/Report/Loadable";
import AdminGSTINReport from "containers/Admin/GstinReport/Loadable";
import ProtectedRoute from "./utils/Protected";
import UserActivity from "containers/Admin/UserActivity/Loadable";
import GSTR7DataUpload from "containers/gstr7/DataUpload/Loadable";
import GSTR7Summary from "containers/gstr7/GSTR7Summary/Loadable";
import GSTR7File from "containers/gstr7/FileGSTR7/Loadable";
import GSTR7Cash from "containers/gstr7/CashBalance/Loadable";
import GSTR8DataUpload from "containers/gstr8/DataUpload/Loadable";
import GSTR8Cash from "containers/gstr8/CashBalance/Loadable";
import GSTR8File from "containers/gstr8/FileGSTR8/Loadable";
//  import GSTR8Prepare from "containers/gstr8/PrepareSave/Loadable";
import GSTR8Prepare from "containers/gstr8/Prepare&Save/Loadable";

import GSTR6View from "containers/gstr6/View/Loadable";
import GSTR6DataUpload from "containers/gstr6/DataUpload/Loadable";
import GSTR6A from "containers/gstr6/gstr6a/Loadable";
import GSTR2XPrepare from "containers/gstr2X/PrepareData/Loadable";
import GSTR2XSave from "containers/gstr2X/SaveData/Loadable";
import GSTR2XFile from "containers/gstr2X/File2X/Loadable";
import ITC04Upload from "containers/ITC-04/DataUpload/Loadable";
import ITC04View from "containers/ITC-04/ViewData/Loadable";
import ITC04Prepare from "containers/ITC-04/PrepareReturn/Loadable";
import ITC04Analytics from "containers/ITC-04/Analytics/Loadable";
import ITC04File from "containers/ITC-04/FileReturn/Loadable";
import {
  saveLocalStorage,
  getToken,
  getLocalStorage,
} from "components/Helper/Helper";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { IdleTimerProvider } from "react-idle-timer";
import history from "utils/history";
import axios from "axios";
import ForgotPassword from "containers/ResetPassword/ResetPassword";
import apiReport from "containers/Admin/ApiReport/Loadable";
import ISDdetails from "containers/gstr6/ISDdetails/Loadable";
import GSTR6Tab from "containers/gstr6/gstr6Tab/Loadable";
import PocEinvoice from "containers/PocEinvoice/Loadable";
import ManagePartner from "containers/Admin/ManagePartner";
import Dashboard from "containers/Admin/Dashboard";
import Table3 from "containers/gstr8/Prepare&Save/Table3";
import Table31 from "containers/gstr8/Prepare&Save/Table31";
import Table4 from "containers/gstr8/Prepare&Save/Table4";
import Table41 from "containers/gstr8/Prepare&Save/Table41";
import Tutorials from "containers/Tutorial/Loadable";
import IMSPrepare from 'containers/InvoiceMgmtSystem/Prepare/Loadable'
import IMSSave from 'containers/InvoiceMgmtSystem/Save/Loadable'

// Routes for Einvoice New
import EinvDataUploadNew from 'containers/New_Einvoice/DataUpload/Loadable';
import FailedInvoiceNew from 'containers/New_Einvoice/FailedInvoices/Loadable';
import EwayBillNew from 'containers/New_Einvoice/EwayBill/Loadable';
import EinvoiceNew from "containers/New_Einvoice/Einvoice";
import ResetPassNew from 'containers/ResetPassword/ResetPassNew';
  import EWBRecoDataUpload from "containers/ewaybill_reco/DataUpload/Loadable";
import EWBRecoFetch from "containers/ewaybill_reco/Fetch/Loadable";
import EWBRecoReconcilation from "containers/ewaybill_reco/Reconcilation/Loadable";

import GSTR9NewDataUpload from "containers/GSTR_9_New/DataUpload/Loadable";
import GSTR9NewFetchReconcile from "containers/GSTR_9_New/FetchReconcile/Loadable";
import GSTR9NewViewPrepare from "containers/GSTR_9_New/ViewPrepare/Loadable";
import GSTR9NewSave from "containers/GSTR_9_New/Save/Loadable";
import GSTR9File from "containers/GSTR_9_New/File/Loadable";
import GSTR9CNewFetch from "containers/GSTR9C_New/Fetch/Loadable";
import GSTR9CNewPrepare from "containers/GSTR9C_New/Prepare/Loadable";
import GSTR9CNewSave from "containers/GSTR9C_New/Save/index";
import GSTR9CNewFile from "containers/GSTR9C_New/File/Loadable";

// Routes fro Help and Support
import HelpAndSupport from "containers/HelpAndSupport/Loadable";
import Manual from "containers/Manual/Loadable";

// Routes for IMS Reco
import ImsRecoUpload from "containers/ImsReco/DataUpload/Loadable";
import ImsRecoFetch from "containers/ImsReco/Fetch/Loadable";
import ImsReco from "containers/ImsReco/Reco/Loadable";
import ImsRecoSave from "containers/ImsReco/Save/Loadable";
import ImsRecoOutward from "containers/ImsReco/Outward/Loadable";
// Routes for GSTR-2A/2B Reco enhancement
import Gstr2a2bDataUpload from "containers/gstr2a2bNewEnhancement/DataUpload/Loadable";
import Gstr2a2bView from './containers/gstr2a2bNewEnhancement/View/Loadable';
import Gstr2A2BFetch from "containers/gstr2a2bNewEnhancement/Fetch";
import Gstr2A2BReconciliation from "containers/gstr2a2bNewEnhancement/Reconciliation";
import Gstr2A2BITCregister from "containers/gstr2a2bNewEnhancement/ITCregister";

// Notes Route
import Notes from "containers/Notes_module/Notes/Notes";
// Notice Route
import Notices from "containers/Notice/Notice/index";
import Email from "containers/Notice/EmailConfig/index"
import EmailMaster from "containers/Notice/EmailMaster";
import ExternalLinks from 'containers/ExternalLinks/Loadable';

// chatbot components
import FloatingChatButton from "components/FloatingChat";
import ChatBot from 'containers/ChatBot/Loadable';
import GuestChatBot from 'containers/ChatBot/GuestChatBotLoadable';

import TemplateMapping from 'containers/Template_Mapping/Loadable';

var idleTimer = null;
var isAuthenticated = false;

function onIdle(e) {
  window.alert("Session Timeout !! Please login again");
  history.push("/logout");
  window.location.reload();
}
axios.interceptors.request.use((req) => {
  return req;
});

axios.interceptors.request.use((req) => {
  return req;
});

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log("error", error);
    // console.log("Request config from interceptor:", error.config);

    if (error.response.status == "402") {
      window.alert("Invalid Token Validation !! Please login again");
      console.log("history", history);
      history.push("/logout");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

function App({ location }) {
  return (
    <div>
      <IdleTimerProvider
        ref={(ref) => {
          idleTimer = ref;
        }}
        element={document}
        //  onActive={onActive}
        onIdle={onIdle}
        // onAction={onAction}
        debounce={250}
        // timeout={3000}
        timeout={900000}
      />
      <Switch location={location}>
        <Route path="/poc" exact component={PocEinvoice} />
        <Route path="/newlogin" exact component={NewLoginPage} />
        <Route path="/" exact component={LoginPage} />
        <Route path="/gtaxpro-chatbot" exact component={GuestChatBot} />
        {/* <ProtectedRoute path="/eInv/upload" exact component={NewUploadPage} /> */}
        <ProtectedRoute
          path="/eInv/uploadb2c"
          exact
          component={UploadPageB2C}
        />
        <ProtectedRoute path="/landing" exact component={LandingPage} />
        <ProtectedRoute path="/ProfilePage" exact component={ProfilePage} />
        {/* <ProtectedRoute path="/eInv/failed" exact component={FailedInvoice} /> */}
        {/* <ProtectedRoute
          path="/eInv/processed"
          exact
          component={ProcessedInvoice}
        /> */}
        <ProtectedRoute
          path="/eInv/progress"
          exact
          component={UploadProgress}
        />
        <ProtectedRoute path="/eInv/reports" exact component={Reports} />
        <ProtectedRoute
          path="/eInv/schedule/progress"
          exact
          component={ScheduleProgress}
        />
        <ProtectedRoute path="/eInv/b2cinvoices" exact component={B2CInvoice} />
        {/* <Route path="/b2c/invoices" exact component={B2CInvoices} /> */}
        <ProtectedRoute path="/b2c/invoices" component={NewB2CInvoices} />
        <ProtectedRoute path="/b2c/upload" exact component={B2CNewUploadPage} />
        {/* <ProtectedRoute path="/eInv/ewaybill" exact component={EwayBill} /> */}
        {/* Commenting ewb consolidate route */}
        {/* <ProtectedRoute
          path="/eInv/consolidate"
          exact
          component={ConsolidateInvoice}
        /> */}
        <ProtectedRoute
          path="/eWayBill/upload"
          exact
          component={UploadEwayBill}
        />
        <ProtectedRoute
          path="/eWayBill/EwayBillPartB"
          exact
          component={EwayBillPartB}
        />
        <ProtectedRoute
          path="/eWay/EwayBillConsolidate"
          exact
          component={EwayBillConsolidate}
        />
        <ProtectedRoute
          path="/eWayBill/EwayBillGet"
          exact
          component={EwayBillGet}
        />
        {/* <ProtectedRoute path="/gstr/upload" exact component={UploadAnx1} /> */}
        {/* <ProtectedRoute
          path="/gstr/uploadedFiles"
          exact
          component={UploadedDataAnx1}
        /> */}
        {/* <ProtectedRoute path="/gstr/DataFetch" exact component={DataFetch} /> */}
        {/* <ProtectedRoute
          path="/gstr/reconciliation"
          exact
          component={Reconciliation}
        /> */}
        {/* <ProtectedRoute
          path="/gstr/fileProgress"
          exact
          component={Gstare2aFileProgress}
        />
        <ProtectedRoute
          path="/gstr/pendingInvoices"
          exact
          component={Gstr2aPendingInvoices}
        /> */}
        {/* <ProtectedRoute
          path="/gstr/purchaseSummary"
          exact
          component={PurchaseSummary}
        /> */}
        {/* <ProtectedRoute
          path="/gstr/gstr2b"
          exact
          component={Gstr2bReconciliation}
        /> */}
        {/* <ProtectedRoute path="/gstr/failed" exact component={FailedAnx1} /> */}
        <ProtectedRoute path="/gstr1/upload" exact component={UploadGstr1} />
        <ProtectedRoute
          path="/gstr1/uploadProgress"
          exact
          component={UploadProgres}
        />
        <ProtectedRoute
          path="/gstr1/previewAndSubmit"
          exact
          component={PreviewAndSubmit}
        />
        <ProtectedRoute path="/gstr1/summary" exact component={Summary} />
        <ProtectedRoute
          path="/gstr1/uploadedDate"
          exact
          component={UploadedDataGstr1}
        />
        <ProtectedRoute path="/gstr1/saveGstr1" exact component={SaveGstr1} />

        {/* GSTR-1 Enhancement Routes */}
        <ProtectedRoute path="/gstr1New/upload" exact component={Gstr1DataUpload} />
        <ProtectedRoute path="/gstr1New/fetch&Reconcile" exact component={Gstr1FetchAndReconcile} />
        <ProtectedRoute path="/gstr1New/viewData" exact component={Gstr1ViewData} />
        <ProtectedRoute path="/gstr1New/save" exact component={Gstr1Save} />
        <ProtectedRoute path="/gstr1New/File" exact component={Gstr1File} />

        <ProtectedRoute path="/gstr6/view" exact component={GSTR6View} />

        <ProtectedRoute
          path="/gstr7/upload"
          exact
          component={GSTR7DataUpload}
        />
        <ProtectedRoute path="/gstr7/summary" exact component={GSTR7Summary} />
        <ProtectedRoute path="/gstr7/file" exact component={GSTR7File} />
        <ProtectedRoute path="/gstr7/cash" exact component={GSTR7Cash} />


        <ProtectedRoute path="/gstr8/upload" exact component={GSTR8DataUpload} />
        <ProtectedRoute path="/gstr8/cash" exact component={GSTR8Cash} />
        <ProtectedRoute path="/gstr8/file" exact component={GSTR8File} />
        {/* <ProtectedRoute path="/gstr8/prepare" exact component={GSTR8Prepare} /> */}
        <ProtectedRoute path="/gstr8/prepare" exact component={GSTR8Prepare} />
        <ProtectedRoute path="/gstr8/table3" exact component={Table3} />
        <ProtectedRoute path="/gstr8/table4" exact component={Table4} />
        <ProtectedRoute path="/gstr8/table41" exact component={Table41} />
        <ProtectedRoute path="/itc04/upload" exact component={ITC04Upload} />
        <ProtectedRoute path="/itc04/view" exact component={ITC04View} />
        <ProtectedRoute path="/itc04/Prepare" exact component={ITC04Prepare} />
        <ProtectedRoute path="/itc04/File" exact component={ITC04File} />
        <ProtectedRoute
          path="/itc04/Analytics"
          exact
          component={ITC04Analytics}
        />
        <ProtectedRoute
          path="/gstr6/upload"
          exact
          component={GSTR6DataUpload}
        />
        <ProtectedRoute path="/gstr6/gstr6a" exact component={GSTR6A} />
        <ProtectedRoute path="/gstr6/ISDdetails" exact component={ISDdetails} />
        <ProtectedRoute path="/gstr6/gstr6" exact component={GSTR6Tab} />

        <ProtectedRoute
          path="/gstr2X/prepare"
          exact
          component={GSTR2XPrepare}
        />
        <ProtectedRoute path="/gstr2X/save" exact component={GSTR2XSave} />
        <ProtectedRoute path="/gstr2X/file" exact component={GSTR2XFile} />

        <ProtectedRoute path="/gstr3b/upload" exact component={UploadGstr3b} />
        <ProtectedRoute path="/gstr3b/save" exact component={SavePageGSTR3B} />


        <ProtectedRoute path="/gstr9/upload" exact component={UploadGstr9} />
        <ProtectedRoute
          path="/gstr9/uploadedDate"
          exact
          component={UploadedDataGstr9}
        />

        <ProtectedRoute
          path="/gstr9c/prepareGstr9c"
          exact
          component={PrepareGSTR9C}
        />
        <ProtectedRoute
          path="/gstr9c/saveGstr9c"
          exact
          component={SaveGSTR9C}
        />

        <ProtectedRoute path="/gstr9/saveGstr9" exact component={SaveGstr9} />
        {/* GSTR-9 New Enhancement Routes */}
        <ProtectedRoute path="/gstr9_new/upload" exact component={GSTR9NewDataUpload} />
        <ProtectedRoute path="/gstr9_new/fetch_recocile" exact component={GSTR9NewFetchReconcile} />
        <ProtectedRoute path="/gstr9_new/view_prepare" exact component={GSTR9NewViewPrepare} />
        <ProtectedRoute path="/gstr9_new/save" exact component={GSTR9NewSave} />
        <ProtectedRoute path="/gstr9_new/file" exact component={GSTR9File} />

        {/* <ProtectedRoute
          path="/gstr9c/prepareGstr9c"
          exact
          component={PrepareGSTR9C}
        />
        <ProtectedRoute
          path="/gstr9c/saveGstr9c"
          exact
          component={SaveGSTR9C}
        /> */}
        <ProtectedRoute path="/gstr9c_new/fetch" exact component={GSTR9CNewFetch} />
        <ProtectedRoute path="/gstr9c_new/prepare" exact component={GSTR9CNewPrepare} />
        <ProtectedRoute path="/gstr9c_new/save" exact component={GSTR9CNewSave} />
        <ProtectedRoute path="/gstr9c_new/file" exact component={GSTR9CNewFile} />
        <ProtectedRoute
          path="/gstr3b/progress"
          exact
          component={UploadedDataGstr3b}
        />
        <ProtectedRoute
          path="/gstr3b/fileProgress"
          exact
          component={FileProgressGstr3b}
        />
        <ProtectedRoute
          path="/gstr3b/previewAndSubmit"
          exact
          component={PreviewAndSubmitR3B}
        />
        <ProtectedRoute path="/gstr3b/summary" exact component={SummaryR3B} />
        <ProtectedRoute path="/logout" exact component={Logout} />
        <ProtectedRoute path="/NotFound" exact component={NotFoundPage} />
        <ProtectedRoute path="/invoiceDetail" exact component={InvoiceDetail} />
        <ProtectedRoute path="/fetchGstnDetail" exact component={UploadGstin} />
        <ProtectedRoute path="/trackReturn" exact component={TrackReturn} />
        <ProtectedRoute path="/vendorMaster" exact component={VendorMaster} />

        <ProtectedRoute
          path="/analyticsGSTR1VS3B"
          exact
          component={AnalyticsGSRT1VS3B}
        />
        <ProtectedRoute
          path="/analyticsGSTR3BVS2A"
          exact
          component={GSTR3BVSGSTR2A}
        />
        <ProtectedRoute path="/returnFilling" exact component={ReturnFilling} />

        <ProtectedRoute path="/rcmLiability" exact component={RCMLiability} />

        <ProtectedRoute path="/ewayBillReco" exact component={EWayBillReco} />
        <ProtectedRoute
          path="/turnoverAnalysis"
          exact
          component={TurnOverAnalysis}
        />
        <ProtectedRoute path="/hsnAnalysis" exact component={HSNAnalysis} />
        <ProtectedRoute
          path="/hsnAnalysisInward"
          exact
          component={HSNAnalysisInward}
        />
        <ProtectedRoute
          path="/taxDischarged"
          exact
          component={TaxDischargedAnalysis}
        />
        <ProtectedRoute path="/itcAnalysis" exact component={ITCAnalysis} />
        <ProtectedRoute
          path="/ledgerAnalysis"
          exact
          component={LedgerBalanceAnalysis}
        />
        <ProtectedRoute
          path="/creditAnalysis"
          exact
          component={CreditNoteAnalysis}
        />

        {/* <ProtectedRoute path="/DataAnalytics" exact component={DataAnalytics} /> */}
        <ProtectedRoute
          path="/DataFetch/fetchDetail"
          exact
          component={DataFetchHome}
        />
        <ProtectedRoute
          path="/DataFetch/CashITCBalance"
          exact
          component={CashITCBalance}
        />
        <ProtectedRoute
          path="/DataFetch/CashITCLedger"
          exact
          component={CashITCLedger}
        />

        <ProtectedRoute
          path="/supplierDetails"
          exact
          component={SupplierDetails}
        />

        <ProtectedRoute
          path="/gtaxpro_tutorial"
          exact
          component={Tutorials}
        />

        <ProtectedRoute
          path="/ims/prepare"
          exact
          component={IMSPrepare}
        />
        <ProtectedRoute
          path="/ims/save"
          exact
          component={IMSSave}
        />
        {/* Routes for Einvoice New */}
        <ProtectedRoute path="/eInv/upload" exact component={EinvDataUploadNew} />
        <ProtectedRoute path="/eInv/failed" exact component={FailedInvoiceNew} />
        <ProtectedRoute
          path="/eInv/processed"
          exact
          component={EinvoiceNew}
        />
        <ProtectedRoute path="/eInv/ewaybill" exact component={EwayBillNew} />
        <ProtectedRoute path="/ewb_reco/upload" exact component={EWBRecoDataUpload} />
        <ProtectedRoute path="/ewb_reco/fetch" exact component={EWBRecoFetch} />
        <ProtectedRoute path="/ewb_reco/reconcilation" exact component={EWBRecoReconcilation} />
        <ProtectedRoute
          path="/gtaxpro_manuals"
          exact
          component={Manual}
        />
        <ProtectedRoute
          path="/gtaxpro_help_support"
          exact
          component={HelpAndSupport}
        />

        <ProtectedRoute path="/imsReco/dataUpload" exact component={ImsRecoUpload} />
        <ProtectedRoute path="/imsReco/fetch" exact component={ImsRecoFetch} />
        <ProtectedRoute path="/imsReco/reco" exact component={ImsReco} />
        <ProtectedRoute path="/imsReco/save" exact component={ImsRecoSave} />
        <ProtectedRoute path="/imsReco/outward" exact component={ImsRecoOutward} />
        
        <ProtectedRoute
          path="/gstr2a2b/upload"
          exact
          component={Gstr2a2bDataUpload}
        />
         <ProtectedRoute
          path="/gstr2a2b/view"
          exact
          component={Gstr2a2bView}
        />
        <ProtectedRoute
          path="/gstr2a2b/fetch"
          exact
          component={Gstr2A2BFetch}
        />
         <ProtectedRoute
          path="/gstr2a2b/reconciliation"
          exact
          component={Gstr2A2BReconciliation}
        />
         <ProtectedRoute
          path="/gstr2a2b/itcregister"
          exact
          component={Gstr2A2BITCregister}
        />
        <ProtectedRoute path="/repository" exact component={Notes} />
         <ProtectedRoute path="/Notice/Notice" exact component={Notices}/>
         <ProtectedRoute path="/Notice/Email" exact component={Email}/>
        <ProtectedRoute path="/notice/emailMaster" exact component={EmailMaster}/>

        <ProtectedRoute path="/external_links" exact component={ExternalLinks} />
        <ProtectedRoute path="/template_mapping" exact component={TemplateMapping} />

          
          <ProtectedRoute path="/chat_bot/:parentId" exact component={ChatBot} />
          <ProtectedRoute path="/chat_bot" exact component={ChatBot} />
        {/* <ProtectedRoute
          path="/userManagement"
          exact
          component={UserManagement}
        />
        <ProtectedRoute path="/managePassInv" component={ManagePassInv} />
        <ProtectedRoute path="/managePincode" exact component={ManagePincode} />
        <ProtectedRoute path="/manageHsncode" exact component={ManageHsncode} />
        <ProtectedRoute path="/manageGroup" exact component={ManageGroup} />
        <ProtectedRoute path="/dashboard" exact component={Dashboard} />
        <ProtectedRoute path="/userModules" exact component={UserModule} />
        <ProtectedRoute
          path="/profileManagement"
          exact
          component={ProfileManagement}
        />
        <ProtectedRoute path="/manageModule" exact component={ManageModules} />
        <ProtectedRoute
          path="/manageCompanies"
          exact
          component={ManageCompanies}
        />
        <ProtectedRoute
          path="/managePartner"
          exact
          component={ManagePartner}
        /> */}
        {/* <Route path="/resetpassword" exact component={ForgotPassword} /> */}
        <Route path="/resetpassword" exact component={ResetPassNew} />

        {/* <ProtectedRoute path="/company/:id" exact component={CompanyDetail} />
        <ProtectedRoute path="/setting" exact component={AdminSetting} />
        <ProtectedRoute path="/report" exact component={AdminReport} />
        <ProtectedRoute
          path="/gstinreport"
          exact
          component={AdminGSTINReport}
        />
        <ProtectedRoute path="/useractivity" exact component={UserActivity} />
        <ProtectedRoute path="/apireport" exact component={apiReport} /> */}
      </Switch>
      <Footer />
      <FloatingChatButton />
    </div>
  );
}

export default withRouter(App);
